import { Link, LinkProps } from '@tanstack/react-router';

export type NavItem = { text: string } & Pick<LinkProps, 'to' | 'params'>;

interface NavPillsProps {
  items: NavItem[];
  className?: string;
}

const NavPills = ({ items = [], className = '' }: NavPillsProps) => {
  return (
    <ul className={`nav nav-pills bg-light mb-5 p-1 border border-line rounded ${className}`}>
      {items.map((item, index) => (
        <li className="nav-item" key={index}>
          <Link to={item.to} params={item.params} className="nav-link" activeOptions={{ exact: true }} activeProps={{ className: 'active' }}>
            {item.text}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default NavPills;
